import { useState } from "react";
import { DELETE_PRODUCT_SEARCH_TAGS } from "../../Queries/products";
import { useMutation } from "@apollo/client";
import { UseNotification } from "../../../Notification/Library/UseNotification";
import { useTranslation } from 'react-i18next';
import { GetApolloErrorText } from "../../../../GlobalFunctions/helper";

const UseDeleteProductSearchTags = (selectedItems,productID,lang,OnCompleted) => {

    const {t} = useTranslation();
    const {AddNotification} = UseNotification();

    const [showDeleteNotification,SetShowDeleteNotification] = useState(false);

    const [DelProductSearchTags] = useMutation(DELETE_PRODUCT_SEARCH_TAGS,{
        onCompleted:(d) => {

            AddNotification(t("TheyAreGone"),true);
            if(OnCompleted)
                OnCompleted(d.DeleteProductSearchTags);
        },
        onError:(err) => {          
            AddNotification(GetApolloErrorText(err),false);
        }
    });

    const ShowDeleteNotification = (value) => {

        if(selectedItems.length > 0)
            SetShowDeleteNotification(value)
        else
        {
            AddNotification(t("NoSelectedRows"),false);
        }
    }

    const DeleteProductSearchTags = (action) => {

        if(action)
        {              
            DelProductSearchTags({
                variables:{
                    productSearchTagIDs:selectedItems.join(","),
                    productID,
                    lang
                }
            })
        }

        SetShowDeleteNotification(false);
    }

    return{
        showDeleteNotification,
        ShowDeleteNotification,
        DeleteProductSearchTags
    }
}

export default UseDeleteProductSearchTags;